import { AnimatePresence, motion } from "framer-motion";
import { useSelector } from "react-redux";

export default function PodcastModal({ isModalOpen, setIsModalOpen }) {
  const { podcast } = useSelector((state) => state.podcast);

  const getInitials = (name) => {
    return name
      ?.split(" ")
      .map((word) => word.charAt(0).toUpperCase())
      .join("");
  };

  return (
    <AnimatePresence>
      {isModalOpen && (
        <motion.div
          key="modal-background"
          onClick={() => setIsModalOpen(false)}
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-20"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
        >
          <motion.div
            key="modal-content"
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="bg-background rounded-xl shadow-xl p-2 w-[400px]  "
          >
          
            <div className="bg-background  w-full rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 h-[400px] overflow-hidden flex flex-col">
             
              <div
                className="relative  min-h-40 max-h-40 overflow-hidden flex justify-center items-center bg-gradient-to-r from-blue-500 to-blue-600"
              >
                <h1 className="text-white text-6xl font-bold">
                  {getInitials(podcast.name)}
                </h1>
                {podcast.newIdea && (
                  <span className="absolute top-4 z-50 right-4 bg-black text-white text-xs font-medium px-3 py-1 rounded-full shadow-sm">
                    Nueva Idea
                  </span>
                )}
              </div>

             
              <div className="p-6 flex flex-col  flex-grow">
                
                <div className="mb-7">
                  <h2 className="text-2xl font-bold text-text mb-2">
                    {podcast.name}
                  </h2>
                  <p className="text-sm text-gray-600">
                    {podcast.description || "Sin descripción"}
                  </p>
                </div>

              
                <div className="space-y-3">
                  
                  <div className="flex items-center text-sm text-gray-700">
                    <svg
                      className="w-4 h-4 mr-2 text-gray-500"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    <span>
                      <span className="font-medium">Plan Mensual:</span>{" "}
                      {podcast.monthlyPlan ? "Activo" : "Inactivo"}
                    </span>
                  </div>

                 
                  <div className="flex items-center text-sm text-gray-700">
                    <svg
                      className="w-4 h-4 mr-2 text-gray-500"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span>
                      <span className="font-medium">Plan Activo:</span>{" "}
                      {podcast.planActive ? "Sí" : "No"}
                    </span>
                  </div>

                  
                  <div className="flex items-center text-sm text-gray-700">
                    <svg
                      className="w-4 h-4 mr-2 text-gray-500"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0-4H3m15 0h3m-3-7a7 7 0 00-7-7m0 0a7 7 0 00-7 7m7-7v4m0-4h14m-14 0H3"
                      />
                    </svg>
                    <span>
                      <span className="font-medium">Solo Audio:</span>{" "}
                      {podcast.onlyAudio ? "Sí" : "No"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}